import * as React from "react";
import { cn } from "../../lib/cn";

const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type, ...props }, ref) => (
    <input
      type={type}
      ref={ref}
      className={cn(
        "w-full rounded-[14px] border border-line bg-white/[0.04] px-4 py-[0.95rem] text-foreground placeholder:text-foreground/30 focus:outline-2 focus:outline-accent-soft focus:border-accent-ring",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";

export { Input };
